/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

import {createPartialResponse} from './createPartialResponse.mjs';
import {Plugin} from './Plugin.mjs';
import './_version.mjs';


/**
 * @namespace workbox.rangeRequests
 */

export {
  createPartialResponse,
  Plugin,
};
